import { InjectionToken } from '@angular/core';
import { LOGOUT_TYPE } from '../entra-id-config';

export const LOGOUT_BEHAVIOR = new InjectionToken<LOGOUT_TYPE>(LOGOUT_TYPE.REDIRECT);
